/**
 *
 * TagSkeleton
 *
 */

import React, { memo } from 'react';

import Skeleton from '..';

function TagSkeleton(props) {
  return <Skeleton variant="circular" width={114} {...props} />;
}

export default memo(TagSkeleton);
